export enum CancelStep {
  CONFIRMATION = 'confirmation',
  COMPLETE = 'complete',
  FORM = 'form',
}
